import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "swatch"]

  connect() {
    this.syncSelectedState(this.currentColor())
  }

  select(event) {
    event.preventDefault()

    const color = event.currentTarget.dataset.color
    if (!color || !this.hasInputTarget) return

    this.inputTarget.value = color
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.syncSelectedState(color)
  }

  currentColor() {
    if (this.hasInputTarget && this.inputTarget.value) return this.inputTarget.value
    if (!this.hasSwatchTarget) return null

    return this.swatchTargets[0].dataset.color
  }

  syncSelectedState(selectedColor) {
    if (!selectedColor && this.hasSwatchTarget) {
      selectedColor = this.swatchTargets[0].dataset.color
      if (this.hasInputTarget) this.inputTarget.value = selectedColor
    }

    this.swatchTargets.forEach((swatch) => {
      const selected = swatch.dataset.color.toLowerCase() === selectedColor.toLowerCase()
      swatch.setAttribute("aria-pressed", selected ? "true" : "false")
    })
  }
}
